module.exports = __webpack_public_path__ + "img/spirit_small_3.c2e23a22.png";